import React, { useEffect, useState } from 'react';
import { compose } from 'ramda';
import { Typography } from '@deeptrue-frontend/ui';
import signInSplash from 'assets/images/sign-in.png';
import { parseErrorsToFormik, errorsValidation } from 'components/Forms/utils';
import RecoverPassword, {
  SubmitHandler,
} from 'components/Forms/RecoverPassword';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import { withMetaDescription } from 'components/HeadProvider/HeadProvider';
import { SidePage } from 'components/Layout';
import api from 'api/api';
import ROUTES from 'consts/routing';
import { useFormatMessage } from 'components/IntlProvider';

const { connect, actions } = StoreProvider;

const PasswordReset = ({ match: { params }, history }: any) => {
  const [isCheckingToken, setIsCheckingToken] = useState(true);
  const t = useFormatMessage();

  useEffect(() => {
    api.resources
      .checkPasswordResetToken(params.key)
      .then(() => {
        setIsCheckingToken(false);
      })
      .catch(() => {
        history.push('/recover?action=token_invalid');
      });
    // eslint-disable-next-line
  }, []);

  const onSubmit: SubmitHandler = (
    { new_password, new_password_confirm },
    formHelpers
  ) => {
    return api.resources
      .forgotPasswordNewPassword({
        new_password,
        new_password_confirm,
        reset_key: params.key,
      })
      .then(() => {
        formHelpers.setSubmitting(false);
        history.push(`${ROUTES.SIGN_IN}?action=pass_reset`);
      })
      .catch(({ response }) => {
        if (errorsValidation.is400Group(response.status)) {
          formHelpers.setErrors(parseErrorsToFormik(response.data));
        }
      })
      .finally(() => {
        formHelpers.setSubmitting(false);
      });
  };

  return (
    <SidePage
      title={t('pages.auth.password', 'Set new password')}
      splashImage={signInSplash}
      slogan={
        <Typography color="white" variant="h4" mt="8rem">
          {t(
            'pages.auth.header',
            "On deeptrue's workbenches you will find well-founded, ready-to-go insight tools"
          )}
        </Typography>
      }
    >
      {isCheckingToken ? null : <RecoverPassword onSubmit={onSubmit} />}
    </SidePage>
  );
};

export default compose(
  connect(null, {
    signUp: actions.authActions.signUp,
  }),
  withMetaDescription({ title: 'Set new password' })
)(PasswordReset);
